import { MapPinOff } from "@/components/icons";
import type { ReloadNoticeLabel } from "@/components/app-update/reload-notice";

export const MAP_FAILURE_NOTICE: ReloadNoticeLabel = {
  title: "The map didn't load",
  icon: MapPinOff,
};
